import React from 'react';
import useBusinessLocations from '../../../../hooks/useBusinessLocations';
import Name from './Name';
import Location from './Location';
import TradingHours from './TradingHours';
import ProfileLink from './ProfileLink';
import Reviews from './Reviews';
import Call from './Call';

const Layout3 = ({ data, url, aggregateContacts, regionCitySearch }) => {
  const {
    name,
    locations: businessLocations,
    servicing,
    distance,
    display_reviews: displayReviews,
    opening_hours: openingHours,
    aggregate_reviews: reviewAggregates,
  } = data || {};

  const { locations } = useBusinessLocations(businessLocations);

  const { phones, mobiles } = aggregateContacts || {};
  const { average_rating: averageRating, review_count: count } =
    reviewAggregates || {};

  const contacts = [...phones, ...mobiles];

  return (
    <div className="Listview__Card__Layout Listview__Card__Layout--3">
      <TradingHours openingHours={openingHours} />
      <div className="Listview__Card__Layout__body">
        <div className="Listview__Card__Layout__left">
          <ProfileLink url={url} className="Listview__Card__link">
            {name}
          </ProfileLink>
          <Name tag="h3">{name}</Name>
          <Location {...{ distance, locations, servicing, regionCitySearch }} />
          {displayReviews && !!count ? (
            <Reviews averageRating={averageRating} count={count} />
          ) : null}
        </div>
        <div className="Listview__Card__Layout__right">
          <Call number={contacts} />
        </div>
      </div>
    </div>
  );
};

export default Layout3;
